import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/collections-page-image.webp';

const thumbHashString = '/fcBBIAg16ZPd6RFdocHXIjAhA==';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 1.5847457627118644;
const originalWidth = 2244;

const CollectionsPageImage = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CollectionsPageImage;
